<template>
  <q-page padding>
    <div class="row col-12 align">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Controle de Estoque (Compras)
      </p>
      <span class="q-ml-sm q-mb-sm text-brand-5 text-weight-bold">
        Última atualização
        {{ horario.split(" ")[0].split("-").reverse().join("/") }}
        {{ horario.split(" ")[1] }}
      </span>
      <span class="q-ml-sm q-mb-sm">
        <q-btn @click="atualizar" color="positive" round icon="redo" />
      </span>
    </div>

    <section class="row q-mt-md q-gutter-sm text-brand-5 text-weight-bold">
      <div class="col-md-2 q-ml-md q-mt-sm">
        <div>Unidade</div>
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <div class="col-md-2 col-2 q-mt-sm">
        <div>Estoque</div>
        <q-select
          :options="filtros"
          dense
          outlined
          v-model="compra"
          :rules="[(val) => val || 'Campo Obrigatório']"
        />
      </div>
    </section>
    <div class="q-mt-lg text-brand-5">
      <div class="row col-12 justify-between items-center">
        <div>
          <span class="text-brand-5 text-weight-bold texto-titulo-tabela">{{
            "Produtos em estoque" +
            " - " +
            pagination.rowsNumber +
            " " +
            "Itens"
          }}</span>
        </div>
        <div class="row items-center">
          <div>
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              v-model="filtrar"
              placeholder="Buscar"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
          <div>
            <q-btn
              @click="exportar"
              class="q-ml-sm"
              icon="file_upload"
              no-caps
              color="secondary"
              label="Exportar"
            />
          </div>
        </div>
      </div>
      <q-table
        flat
        table-header-class="bg-accent text-weight-bold"
        :rows="rows"
        :columns="columns"
        dense
        color="primary"
        title-class="text-brand-5 text-weight-bold"
        :loading="disable"
        :filter="filtrar"
        class="my-sticky-dynamic"
        hide-pagination
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
        @request="handleRequest"
        ref="tableRef"
      >
        <template #body-cell-delete="props">
          <q-td>
            <span>
              <q-btn
                @click="editar(props.row.id)"
                color="positive"
                round
                icon="edit"
              />
            </span>
            <span>
              <q-btn
                class="q-ml-sm"
                @click="deleteId(props.row.id, props.row.status)"
                color="negative"
                round
                icon="delete"
              />
            </span>
          </q-td>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template #body-cell-product_code="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.product_code
            }}</span>
          </q-td>
        </template>
        <template #body-cell-product_name="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.product_name
            }}</span>
          </q-td>
        </template>
        <template #body-cell-product_group_name="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.product_group_name
            }}</span>
          </q-td>
        </template>
        <template #body-cell-measurement_unit="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.measurement_unit
            }}</span>
          </q-td>
        </template>
        <template #body-cell-measurement_unit_description="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.measurement_unit_description
            }}</span>
          </q-td>
        </template>
        <template #body-cell-product_category_code="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.product_category_code
            }}</span>
          </q-td>
        </template>
        <template #body-cell-price="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.price != null
                ? parseFloat(props.row.price).toFixed(2)
                : ""
            }}</span>
          </q-td>
        </template>
        <template #body-cell-amount="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.amount != null
                ? parseFloat(props.row.amount).toFixed(2)
                : ""
            }}</span>
          </q-td>
        </template>
        <template #body-cell-replacement_amount="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row?.replacement_amount != null
                ? parseFloat(props.row.replacement_amount).toFixed(2)
                : ""
            }}</span>
          </q-td>
        </template>
        <template #body-cell-minimal_amount="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.minimal_amount != null
                ? parseFloat(props.row.minimal_amount).toFixed(2)
                : ""
            }}</span>
          </q-td>
        </template>
        <template #body-cell-max_amount="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.max_amount != null
                ? parseFloat(props.row.max_amount).toFixed(2)
                : ""
            }}</span>
          </q-td>
        </template>
        <template #body-cell-quantidade_em_aberto="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.quantidade_em_aberto != null
                ? parseFloat(props.row.quantidade_em_aberto).toFixed(2)
                : ""
            }}</span>
          </q-td>
        </template>
        <template #body-cell-quantidade_em_aberto_necessidade="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.quantidade_em_aberto_necessidade != null
                ? parseFloat(
                    props.row.quantidade_em_aberto_necessidade
                  ).toFixed(2)
                : ""
            }}</span>
          </q-td>
        </template>
        <template #body-cell-compra_em_aberto="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.compra_em_aberto != null
                ? parseFloat(props.row.compra_em_aberto).toFixed(2)
                : ""
            }}</span>
          </q-td>
        </template>
        <template #body-cell-compra_sugerida="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.compra_sugerida != null
                ? parseFloat(props.row.compra_sugerida).toFixed(2)
                : ""
            }}</span>
          </q-td>
        </template>
        <template #body-cell-created_at="props">
          <q-td>
            <span class="text-brand-5 text-weight-bold">{{
              props.row.created_at.split(" ")[0].split("-").reverse().join("/")
            }}</span>
            <span class="q-ml-sm text-brand-5 text-weight-bold">{{
              props.row.created_at.split(" ")[1]
            }}</span>
          </q-td>
        </template>
      </q-table>
      <div
        v-if="rows.length > 5"
        style="position: absolute; top: 480px; z-index: 400; width: 97%"
      >
        <div class="row col justify-between">
          <q-btn
            icon="chevron_left"
            round
            color="primary"
            @click="scrollLeft"
          />
          <q-btn
            icon="chevron_right"
            color="primary"
            round
            @click="scrollRight"
          />
        </div>
      </div>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "product_code",
    label: "Código do Produto",
    field: "product_code",
    align: "left",
  },
  {
    name: "product_name",
    label: "Produto",
    field: "product_name",
    align: "left",
  },
  {
    name: "product_group_name",
    label: "Grupo do Produto",
    field: "product_group_name",
    align: "left",
  },
  {
    name: "measurement_unit",
    label: "Unidade de Medida",
    field: "measurement_unit",
    align: "left",
  },
  {
    name: "measurement_unit_description",
    label: "Desc.Unid. de Medida",
    field: "measurement_unit_description",
    align: "left",
  },

  {
    name: "product_category_code",
    label: "Categoria",
    field: "product_category_code",
    align: "left",
  },
  {
    name: "price",
    label: "R$ Preço",
    field: "price",
    align: "left",
  },
  {
    name: "amount",
    label: "Estoque Atual",
    field: "amount",
    align: "left",
  },
  {
    name: "replacement_amount",
    label: "Ponto de Reposição",
    field: "replacement_amount",
    align: "left",
  },
  {
    name: "minimal_amount",
    label: "Estoque Crítico",
    field: "minimal_amount",
    align: "left",
  },
  {
    name: "max_amount",
    label: "Estoque Máximo",
    field: "max_amount",
    align: "left",
  },
  {
    name: "quantidade_em_aberto",
    label: "Em Aberto (Voucher)",
    field: "quantidade_em_aberto",
    align: "left",
  },
  {
    name: "quantidade_em_aberto_necessidade",
    label: "Necessidade em Aberto",
    field: "quantidade_em_aberto_necessidade",
    align: "left",
  },
  {
    name: "compra_em_aberto",
    label: "Compra em Aberto",
    field: "compra_em_aberto",
    align: "left",
  },
  {
    name: "compra_sugerida",
    label: "Compra Sugerida",
    field: "compra_sugerida",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const filtrar = ref("");
    const compra = ref("Todos");
    const horario = ref("");
    const unidade = ref();

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 25) => {
      try {
        disable.value = true;
        const response = await store.dispatch("compras/listarCompras", {
          vendor_id: store.state.org.unidadeData.id,
          page,
          per_page: rowsPerPage,
          compra_sugerida: compra.value.value,
          search: filtrar.value,
        });

        rows.value = response.data.results.data;
        horario.value = response.data.results.data[0].data_criacao;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
      } catch (error) {
        disable.value = false;
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const exportar = async () => {
      try {
        await store.dispatch("compras/exportarCompras", {
          vendor_id: store.state.org.unidadeData.id,
          compra_sugerida: compra.value.value,
        });

        $q.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const atualizar = async () => {
      try {
        await store.dispatch("compras/atualizar", {
          vendor_id: store.state.org.unidadeData.id,
          compra_sugerida: compra.value.value,
        });

        $q.notify({
          message: "Relatorio recalculado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o recalcular",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => compra.value,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    const scrollLeft = () => {
      let containerTabela = document.getElementsByClassName(
        "q-table__middle scroll"
      );
      containerTabela[0].scrollLeft -= 150;
    };

    const scrollRight = () => {
      let containerTabela = document.getElementsByClassName(
        "q-table__middle scroll"
      );
      containerTabela[0].scrollLeft += 150;
    };

    onMounted(() => {
      getUnidade;
    });

    return {
      pagination,
      rows,
      disable,
      columns,
      filtrar,
      getDados,
      handleRequest,
      unidade,
      scrollLeft,
      scrollRight,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      filtros: [
        {
          label: "Todos",
          value: 0,
        },
        { label: "Compra em Aberto", value: "compra_em_aberta" },
        { label: "MRP", value: "reposicao" },
        { label: "Compra Sugerida", value: "compra_sugerida" },
      ],
      compra,
      exportar,
      atualizar,
      horario,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 900px;
}
.input {
  width: 180px;
}
.my-sticky-dynamic {
  max-height: 500px;
}
.texto-titulo-tabela {
  font-size: 19px;
}
.align {
  align-items: center;
}
theader tr th {
  white-space: pre-wrap;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
